export const OCC_ENDPOINTS = {
  ticket: '/ticket/',
  calculator: {
    get: '/calculators/',
    calculate: '/calculators/calculate',
  },
  condition: 'products/${productCode}/condition',
  unitPrices: 'products/${productCode}/unitPrices',
  productsByCodes: 'products/sdcodes',
  groupReferences: 'products/${productCode}/group-references',
};
